import { render } from "./DotNotification.vue?vue&type=template&id=3bd5ce11&ts=true"
import script from "./DotNotification.vue?vue&type=script&lang=ts"
export * from "./DotNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__